export default "__VITE_PUBLIC_ASSET__275ba765__"